import React from 'react';

function Navigation({ currentPage, onNavigate, onLogout, userName }) {
  return (
    <div className="top-nav">
      <div className="nav-logo">
        <div className="nav-logo-icon">🏢</div>
        <div className="nav-logo-text">Store Manager</div>
      </div>

      <div className="nav-menu">
        <div 
          className={`nav-item ${currentPage === 'dashboard' ? 'active' : ''}`}
          onClick={() => onNavigate('dashboard')}
        >
          Dashboard
        </div>
        <div 
          className={`nav-item ${currentPage === 'stores' ? 'active' : ''}`}
          onClick={() => onNavigate('stores')}
        >
          People
        </div>
        <div 
          className={`nav-item ${currentPage === 'analytics' ? 'active' : ''}`}
          onClick={() => onNavigate('analytics')}
        >
          Analytics
        </div>
        <div 
          className={`nav-item ${currentPage === 'settings' ? 'active' : ''}`}
          onClick={() => onNavigate('settings')}
        >
          Settings
        </div>
      </div>

      <div className="nav-right">
        <div className="user-profile">
          <div className="user-avatar">
            {userName ? userName.substring(0, 2).toUpperCase() : 'AY'}
          </div>
          <div>
            <div className="user-name">{userName || 'Ahmet Yılmaz'}</div>
            <div className="user-role">Administrator</div>
          </div>
        </div>
        <button className="logout-btn" onClick={onLogout}>
          🚪 Logout
        </button>
      </div>
    </div>
  );
}

export default Navigation;